import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function googleConnectAccountClick() {
  pushClevertapEvent('Google Connect Account Click');
}

export function googleConnectAccountSuccess() {
  pushClevertapEvent('Google Connect Account Success');
}

export function googleConnectAccountFailure(failureReason) {
  pushClevertapEvent('Google Connect Account Failure', {
    'Failure Reason': failureReason,
  });
}

export function googleContinueSetupClick() {
  pushClevertapEvent('Google Continue Setup Click');
}

export function googleContinueSetupSuccess() {
  pushClevertapEvent('Google Continue Setup Success');
}

export function googleContinueSetupFailure(failureReason) {
  pushClevertapEvent('Google Continue Setup Failure', {
    'Failure Reason': failureReason,
  });
}

export function googleDisconnectClick() {
  pushClevertapEvent('Google Disconnect Click');
}

export function googleDisconnectSuccess() {
  pushClevertapEvent('Google Disconnect Success');
}

export function googleConnectAnotherOutletClick() {
  pushClevertapEvent('Google Connect Another Outlet Click');
}

export function googleConnectAnotherOutletSuccess() {
  pushClevertapEvent('Google Connect Another Outlet Success');
}

export function googleConnectAnotherOutletFailure(failureReason) {
  pushClevertapEvent('Google Connect Another Outlet Failure', {
    'Failure Reason': failureReason,
  });
}

export function googleUploadProductsClick() {
  pushClevertapEvent('Google Upload Products Click');
}

export function googleUploadProductsSuccess(numberOfProducts) {
  pushClevertapEvent('Google Upload Products Success', {
    'Number of Products': numberOfProducts,
  });
}

export function googleUploadProductsFailure(numberOfProducts, failureReason) {
  pushClevertapEvent('Google Upload Products Failure', {
    'Number of Products': numberOfProducts,
    'Failure Reason': failureReason,
  });
}

export function googleProductUploadExportClick() {
  pushClevertapEvent('Google Product Upload Export Click');
}

export function googleProductUploadExportSuccess() {
  pushClevertapEvent('Google Product Upload Export Success');
}

export function googleProductUploadExportFailure(failureReason) {
  pushClevertapEvent('Google Product Upload Export Failure', {
    'Failure Reason': failureReason,
  });
}
